module.exports = __webpack_public_path__ + "static/media/banner3.0be9624e.jpg";